export const teachers = [
  {
    slug: "dr-priya-sharma",
    name: "Dr. Priya Sharma",
    subject: "Mathematics & Statistics",
    specialization: "Advanced Calculus, Linear Algebra, Probability",
    experienceYears: 12,
    rating: "4.9",
    totalStudents: "320+",
    totalSessions: "4,800+",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=500&fit=crop&crop=face",
    tags: ["Calculus", "Linear Algebra", "Statistics"],
    bio: "Dr. Priya Sharma holds a PhD in Applied Mathematics from IIT Delhi and has been teaching for over 12 years. Her passion for making complex mathematical concepts accessible has helped hundreds of students achieve top scores in board exams and competitive tests like JEE and SAT. She believes every student can excel in math with the right guidance and approach.",
    qualifications: ["PhD in Applied Mathematics, IIT Delhi", "M.Sc. Mathematics, University of Delhi", "B.Ed, NCERT Certified"],
    languages: ["English", "Hindi"],
    availability: "Mon-Sat, 9 AM - 8 PM IST",
    teachingStyle: "Interactive problem-solving with real-world applications. Uses visual aids and step-by-step breakdowns to simplify complex topics.",
    achievements: ["Published 15+ research papers", "Mathematics Olympiad Gold Medalist", "Best Teacher Award 2023"],
    subjectSlugs: ["mathematics"],
  },
  {
    slug: "prof-james-mitchell",
    name: "Prof. James Mitchell",
    subject: "Physics & Engineering",
    specialization: "Mechanics, Quantum Physics, Thermodynamics",
    experienceYears: 15,
    rating: "4.8",
    totalStudents: "280+",
    totalSessions: "4,200+",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop&crop=face",
    tags: ["Mechanics", "Quantum Physics", "Thermodynamics"],
    bio: "Prof. James Mitchell brings 15 years of teaching experience from top universities in the UK and India. His unique approach combines theoretical rigor with practical demonstrations, making physics intuitive and exciting. He has guided numerous students into prestigious engineering programs worldwide.",
    qualifications: ["MSc Physics, University of Cambridge", "B.Sc Honours Physics, University of Edinburgh", "PGCE Teaching Certification"],
    languages: ["English"],
    availability: "Mon-Fri, 10 AM - 7 PM IST",
    teachingStyle: "Experiment-based learning with real-world demonstrations. Focuses on conceptual clarity before problem-solving.",
    achievements: ["15 years at top universities", "Authored 3 physics textbooks", "200+ students in IIT/NIT"],
    subjectSlugs: ["physics"],
  },
  {
    slug: "ms-aisha-patel",
    name: "Ms. Aisha Patel",
    subject: "English & Literature",
    specialization: "Creative Writing, SAT Prep, Literature Analysis",
    experienceYears: 8,
    rating: "5.0",
    totalStudents: "195+",
    totalSessions: "2,900+",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=500&fit=crop&crop=face",
    tags: ["Creative Writing", "SAT Prep", "Literature"],
    bio: "Ms. Aisha Patel is a published author and award-winning educator with 8 years of experience teaching English language and literature. Her creative teaching methods inspire students to fall in love with reading and writing. She specializes in SAT/IELTS preparation and has helped students gain admission to Ivy League universities.",
    qualifications: ["MA English Literature, JNU", "Creative Writing Certificate, University of Iowa", "IELTS Examiner Certified"],
    languages: ["English", "Hindi", "Gujarati"],
    availability: "Mon-Sat, 8 AM - 6 PM IST",
    teachingStyle: "Discussion-based learning with emphasis on critical thinking and creative expression. Uses literature, films, and current events as teaching tools.",
    achievements: ["Published novelist", "IELTS 9.0 Band Scorer", "50+ students in Ivy League schools"],
    subjectSlugs: ["english"],
  },
  {
    slug: "dr-chen-wei",
    name: "Dr. Chen Wei",
    subject: "Computer Science",
    specialization: "Python, Data Science, Machine Learning",
    experienceYears: 10,
    rating: "4.9",
    totalStudents: "410+",
    totalSessions: "6,100+",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=500&fit=crop&crop=face",
    tags: ["Python", "Data Science", "Machine Learning"],
    bio: "Dr. Chen Wei is a former Google engineer turned educator with 10 years of experience in computer science education. His industry background gives students practical insights into real-world software development. He specializes in Python, data structures, algorithms, and machine learning, making complex CS concepts accessible to beginners and advanced learners alike.",
    qualifications: ["PhD Computer Science, Stanford University", "MS Computer Science, Tsinghua University", "Former Senior Engineer at Google"],
    languages: ["English", "Mandarin"],
    availability: "Tue-Sun, 11 AM - 9 PM IST",
    teachingStyle: "Project-based learning with hands-on coding sessions. Emphasizes building real applications and understanding core CS principles.",
    achievements: ["Ex-Google Senior Engineer", "Open source contributor (10K+ GitHub stars)", "300+ students placed in tech companies"],
    subjectSlugs: ["computer-science"],
  },
  {
    slug: "dr-meera-krishnan",
    name: "Dr. Meera Krishnan",
    subject: "Chemistry",
    specialization: "Organic Chemistry, Biochemistry, JEE Prep",
    experienceYears: 14,
    rating: "4.8",
    totalStudents: "250+",
    totalSessions: "3,700+",
    image: "https://images.unsplash.com/photo-1594824476967-48c8b964c31f?w=400&h=500&fit=crop&crop=face",
    tags: ["Organic Chemistry", "Biochemistry", "JEE Prep"],
    bio: "Dr. Meera Krishnan is a renowned chemistry educator with 14 years of experience. She holds a PhD from IISc Bangalore and has trained thousands of students for JEE, NEET, and board exams. Her molecular model demonstrations and reaction mechanism walkthroughs make organic chemistry intuitive and memorable.",
    qualifications: ["PhD Chemistry, IISc Bangalore", "MSc Chemistry, University of Mysore", "CSIR-NET Qualified"],
    languages: ["English", "Hindi", "Tamil", "Kannada"],
    availability: "Mon-Sat, 9 AM - 7 PM IST",
    teachingStyle: "Visual learning with molecular models and reaction mechanism animations. Focuses on building strong conceptual foundations.",
    achievements: ["14 years teaching experience", "100+ JEE top 1000 rankers", "Chemistry Education Award 2024"],
    subjectSlugs: ["chemistry"],
  },
  {
    slug: "mr-arjun-reddy",
    name: "Mr. Arjun Reddy",
    subject: "Biology & Life Sciences",
    specialization: "Human Anatomy, Genetics, NEET Prep",
    experienceYears: 9,
    rating: "4.9",
    totalStudents: "180+",
    totalSessions: "2,600+",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=500&fit=crop&crop=face",
    tags: ["Anatomy", "Genetics", "NEET Prep"],
    bio: "Mr. Arjun Reddy is a passionate biology educator with 9 years of experience specializing in NEET and medical entrance preparation. His detailed anatomical illustrations and genetics problem-solving techniques have helped hundreds of students secure seats in top medical colleges across India.",
    qualifications: ["MSc Biotechnology, AIIMS", "B.Sc Biology, Osmania University", "NEET Teaching Specialist"],
    languages: ["English", "Hindi", "Telugu"],
    availability: "Mon-Fri, 10 AM - 8 PM IST",
    teachingStyle: "Visual and mnemonics-based learning. Uses diagrams, flowcharts, and memory techniques to make biology retention easy.",
    achievements: ["200+ NEET qualifiers", "Biology teaching innovator", "YouTube channel with 50K+ subscribers"],
    subjectSlugs: ["biology"],
  },
];
